import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import { GetTimestampRequest } from '@/api/timestamp/timestamp.request';

export class TimestampApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly apiUrl: Ref<string>,
  ) { }

  public get getTimestampRequest(): GetTimestampRequest {
    return new GetTimestampRequest(
      this.requestPerformer,
      `${this.apiUrl.value}/report/timestamp`,
      HttpMethods.GET,
    );
  }
}
